import React from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { YEAR_IN_DAYS, PAID, TOI_PLUS } from 'constants/index';
import { setPayloadInfo } from 'utils/primeUtil';
import s from './Offers.scss';

const Offers = ({
  homePageOffers,
  pageType,
  storyPageOffers,
  isWapView,
  subscriptionRes,
  handleOfferClick,
  userData,
  storyTitle,
  msid,
}) => {
  // const { isLoggedIn = undefined } = userData;
  const isLoggedIn = userData?.isLoggedIn ? userData?.isLoggedIn : undefined;

  const prcValue = userData && userData?.prcValue ? userData?.prcValue : 0;
  const getClick = () => {
    if (pageType === 'home') {
      setPayloadInfo('TOIPlus_InlineWidgets|CTA-coupon-click', 'NON_STORY');
      analyticsWrapper(
        'ga',
        'send',
        'event',
        isWapView ? 'mweb' : 'web',
        'TOIPlus_InlineWidgets|CTA-coupon-click',
        `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
        { nonInteraction: 0 },
      );
    } else {
      setPayloadInfo(
        'prime-login_blocker_click_coupon',
        'STORY',
        storyTitle,
        msid,
      );
      analyticsWrapper(
        'ga',
        'send',
        'event',
        isWapView ? 'mweb' : 'web',
        'prime-login_blocker_click_coupon',
        `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
        { nonInteraction: 0 },
      );
    }
    let selectedPlan;
    let accessType;
    if (
      subscriptionRes &&
      Array.isArray(subscriptionRes.plans) &&
      subscriptionRes.plans.length > 0
    ) {
      for (let i = 0; i < subscriptionRes.plans.length; i += 1) {
        if (
          subscriptionRes.plans[i] &&
          subscriptionRes.plans[i].durationInDays &&
          subscriptionRes.plans[i].durationInDays === YEAR_IN_DAYS &&
          subscriptionRes.plans[i].planType &&
          subscriptionRes.plans[i].planType === PAID &&
          subscriptionRes.plans[i].subscription &&
          subscriptionRes.plans[i].subscription.accessType &&
          subscriptionRes.plans[i].subscription.accessType === TOI_PLUS
        ) {
          selectedPlan = subscriptionRes.plans[i].planId;
          accessType = subscriptionRes?.plans[1]?.subscription?.accessType;
        }
      }

      handleOfferClick(selectedPlan, accessType);
    } else {
      handleOfferClick(false, true);
    }
  };
  return (
    <div
      className={`${
        isWapView && pageType === 'home' ? s.container2 : s.container1
      }  ${pageType === 'home' && !isWapView ? s.borderwidth : ''} ${
        pageType === 'home' && isWapView ? s.mb5 : ''
      }`}
    >
      <div
        className={` ${
          isWapView && pageType === 'home'
            ? s.imgandtextcontainer2
            : s.imgandtextcontainer1
        }`}
      >
        <img
          className={`${
            isWapView && pageType === 'home'
              ? s.percentageIcon2
              : s.percentageIcon1
          }`}
          src="https://static.toiimg.com/photo/92831253.cms"
          alt="percentage_icon"
        />
        <div
          className={`${
            isWapView && pageType === 'home' ? s.offerTxt2 : s.offerTxt1
          }`}
          dangerouslySetInnerHTML={{
            __html:
              pageType === 'home'
                ? homePageOffers?.offertxt
                : storyPageOffers?.offertxt,
          }}
        />
      </div>
      <div>
        <button
          className={`${
            isWapView && pageType === 'home' ? s.seeofferBtn2 : s.seeofferBtn1
          }`}
          onClick={getClick}
        >
          {pageType === 'home'
            ? homePageOffers?.ctatxt
            : storyPageOffers?.ctatxt}
        </button>
      </div>
    </div>
  );
};

export default Offers;
